import { defineMessages } from 'react-intl';

const messages = defineMessages({
  historyColAmount: {
    id: 'features.payments.marketplaceHistory.colAmount',
    defaultMessage: 'Amount',
  },
  historyColBuyer: {
    id: 'features.payments.marketplaceHistory.colBuyer',
    defaultMessage: 'Buyer',
  },
  historyColDate: {
    id: 'features.payments.marketplaceHistory.colDate',
    defaultMessage: 'Date',
  },
  purchaseTermsCol: {
    id: 'features.payments.marketplaceHistory.colTerms',
    defaultMessage: 'Terms of Use',
  },
  purchaseTermsView: {
    id: 'features.payments.marketplaceHistory.viewAcceptedTerms',
    defaultMessage: 'View accepted version',
  },
  purchaseTermsTitle: {
    id: 'features.payments.purchaseTerms.dialogTitle',
    defaultMessage: 'Terms of Use you accepted',
  },
  purchaseTermsMeta: {
    id: 'features.payments.purchaseTerms.meta',
    defaultMessage: 'Version {version}, accepted {date}',
  },
  purchaseTermsSuperseded: {
    id: 'features.payments.purchaseTerms.superseded',
    defaultMessage:
      'The seller has since published a newer version. The version you accepted at purchase applies to this order; earlier versions stay archived.',
  },
  purchaseTermsError: {
    id: 'features.payments.purchaseTerms.loadError',
    defaultMessage: 'The accepted Terms of Use could not be loaded.',
  },
  historyColDelivery: {
    id: 'features.payments.marketplaceHistory.colDelivery',
    defaultMessage: 'Delivery',
  },
  historyColGross: {
    id: 'features.payments.marketplaceHistory.colGross',
    defaultMessage: 'Gross',
  },
  historyColItem: {
    id: 'features.payments.marketplaceHistory.colItem',
    defaultMessage: 'Item',
  },
  historyColNet: {
    id: 'features.payments.marketplaceHistory.colNet',
    defaultMessage: 'Net to you',
  },
  historyColPayout: {
    id: 'features.payments.marketplaceHistory.colPayout',
    defaultMessage: 'Payout',
  },
  historyColPlatformFee: {
    id: 'features.payments.marketplaceHistory.colPlatformFee',
    defaultMessage: 'Platform fee',
  },
  historyColProviderFee: {
    id: 'features.payments.marketplaceHistory.colProviderFee',
    defaultMessage: 'Processor fee',
  },
  historyColStatus: {
    id: 'features.payments.marketplaceHistory.colStatus',
    defaultMessage: 'Status',
  },
  historyColType: {
    id: 'features.payments.marketplaceHistory.colType',
    defaultMessage: 'Type',
  },
  historyDeliveryDelivered: {
    id: 'features.payments.marketplaceHistory.deliveryDelivered',
    defaultMessage: 'Delivered',
  },
  historyDeliveryProcessing: {
    id: 'features.payments.marketplaceHistory.deliveryProcessing',
    defaultMessage: 'Processing',
  },
  historyDeliveryRefundFailed: {
    id: 'features.payments.marketplaceHistory.deliveryRefundFailed',
    defaultMessage: 'Refund needs attention — contact support',
  },
  historyDeliveryRefundInProgress: {
    id: 'features.payments.marketplaceHistory.deliveryRefundInProgress',
    defaultMessage: 'Refund in progress',
  },
  historyDeliveryRefunded: {
    id: 'features.payments.marketplaceHistory.deliveryRefunded',
    defaultMessage: 'Refunded',
  },
  historyDeliveryUnavailable: {
    id: 'features.payments.marketplaceHistory.deliveryUnavailable',
    defaultMessage: 'Unavailable — contact support',
  },
  historyItemRemoved: {
    id: 'features.payments.marketplaceHistory.itemRemoved',
    defaultMessage: 'Removed listing',
  },
  historyPayoutCanceling: {
    id: 'features.payments.marketplaceHistory.payoutCanceling',
    defaultMessage: 'Cancellation in progress',
  },
  historyPayoutCancelFailed: {
    id: 'features.payments.marketplaceHistory.payoutCancelFailed',
    defaultMessage: 'Cancellation failed — under review',
  },
  historyPayoutConfirmed: {
    id: 'features.payments.marketplaceHistory.payoutConfirmed',
    defaultMessage: 'Payout confirmed',
  },
  historyPayoutFailed: {
    id: 'features.payments.marketplaceHistory.payoutFailed',
    defaultMessage: 'Payout failed',
  },
  historyPayoutHolding: {
    id: 'features.payments.marketplaceHistory.payoutHolding',
    defaultMessage: 'Holding',
  },
  historyPayoutPaid: {
    id: 'features.payments.marketplaceHistory.payoutPaid',
    defaultMessage: 'Paid out',
  },
  historyPayoutPending: {
    id: 'features.payments.marketplaceHistory.payoutPending',
    defaultMessage: 'Awaiting payment',
  },
  historyPayoutVoided: {
    id: 'features.payments.marketplaceHistory.payoutVoided',
    defaultMessage: 'Voided',
  },
  historyPurchasesEmpty: {
    id: 'features.payments.marketplaceHistory.purchasesEmpty',
    defaultMessage: 'No purchases yet.',
  },
  historyPurchasesTitle: {
    id: 'features.payments.marketplaceHistory.purchasesTitle',
    defaultMessage: 'Purchases',
  },
  historySalesEmpty: {
    id: 'features.payments.marketplaceHistory.salesEmpty',
    defaultMessage: 'No sales yet.',
  },
  historySalesTitle: {
    id: 'features.payments.marketplaceHistory.salesTitle',
    defaultMessage: 'Sales',
  },
  historyStatusPartiallyRefunded: {
    id: 'features.payments.marketplaceHistory.statusPartiallyRefunded',
    defaultMessage: 'Partially refunded',
  },
  historyStatusRefunded: {
    id: 'features.payments.marketplaceHistory.statusRefunded',
    defaultMessage: 'Refunded',
  },
  historyStatusSucceeded: {
    id: 'features.payments.marketplaceHistory.statusSucceeded',
    defaultMessage: 'Paid',
  },
  historyTypeBookingEvent: {
    id: 'features.payments.marketplaceHistory.typeBookingEvent',
    defaultMessage: 'Group session',
  },
  historyTypeCourse: {
    id: 'features.payments.marketplaceHistory.typeCourse',
    defaultMessage: 'Course',
  },
  historyTypeEpisode: {
    id: 'features.payments.marketplaceHistory.typeEpisode',
    defaultMessage: 'Episode',
  },
  historyTypeExercise: {
    id: 'features.payments.marketplaceHistory.typeExercise',
    defaultMessage: 'Exercise',
  },
  historyTypeMeal: {
    id: 'features.payments.marketplaceHistory.typeMeal',
    defaultMessage: 'Meal',
  },
  historyTypeModule: {
    id: 'features.payments.marketplaceHistory.typeModule',
    defaultMessage: 'Module',
  },
  historyTypeNutritionPlan: {
    id: 'features.payments.marketplaceHistory.typeNutritionPlan',
    defaultMessage: 'Nutrition plan',
  },
  historyTypeProgram: {
    id: 'features.payments.marketplaceHistory.typeProgram',
    defaultMessage: 'Program',
  },
  historyTypeWorkout: {
    id: 'features.payments.marketplaceHistory.typeWorkout',
    defaultMessage: 'Workout',
  },
  addCard: {
    id: 'features.payments.walletInstruments.addCard',
    defaultMessage: 'Add card',
  },
  bannerChoosePlan: {
    id: 'features.payments.billingBanner.choosePlan',
    defaultMessage: 'Choose a plan',
  },
  bannerGoToCards: {
    id: 'features.payments.billingBanner.goToCards',
    defaultMessage: 'Cards',
  },
  bannerPastDueWarning: {
    id: 'features.payments.billingBanner.pastDueWarning',
    defaultMessage:
      'Payment failed — the service works until {date}. Settle the debt to avoid suspension.',
  },
  bannerPastDueWarningNoDate: {
    id: 'features.payments.billingBanner.pastDueWarningNoDate',
    defaultMessage: 'Payment failed — settle the debt to avoid suspension.',
  },
  bannerPayNow: {
    id: 'features.payments.billingBanner.payNow',
    defaultMessage: 'Pay now',
  },
  bannerPayNowFailed: {
    id: 'features.payments.billingBanner.payNowFailed',
    defaultMessage:
      'Payment confirmation is taking longer than expected. Check the payment status before trying again.',
  },
  bannerPayNowProcessing: {
    id: 'features.payments.billingBanner.payNowProcessing',
    defaultMessage: 'Charge started — checking status…',
  },
  bannerPayNowSuccess: {
    id: 'features.payments.billingBanner.payNowSuccess',
    defaultMessage: 'Payment succeeded.',
  },
  // Q3/Task 4: the OTHER lock. The organization owes nothing — it simply has no
  // subscription any more — so this sentence names no balance and no debt.
  bannerSubscriptionEndedAlert: {
    id: 'features.payments.billingBanner.subscriptionEndedAlert',
    defaultMessage:
      'This organization has no active plan — choose one to restore its features.',
  },
  bannerSuspendedAlert: {
    id: 'features.payments.billingBanner.suspendedAlert',
    defaultMessage:
      'The subscription is suspended — settle the debt to restore access.',
  },
  bannerTrialInfo: {
    id: 'features.payments.billingBanner.trialInfo',
    defaultMessage: 'Trial period is active until {date}.',
  },
  addToSaved: {
    id: 'features.featuredContent.featuredItem.addToSaved',
    defaultMessage: 'Add to saved',
  },
  buyNow: {
    id: 'features.payments.marketplaceBuyFooter.buy',
    defaultMessage: 'Buy',
  },
  cardColumn: {
    id: 'features.payments.walletInstruments.cardColumn',
    defaultMessage: 'Card',
  },
  currencyToggleLabel: {
    id: 'features.payments.currencyToggle.label',
    defaultMessage: 'Display currency',
  },
  defaultChip: {
    id: 'features.payments.walletInstruments.defaultChip',
    defaultMessage: 'Default',
  },
  deleteCardDescription: {
    id: 'features.payments.walletInstruments.deleteCardDescription',
    defaultMessage:
      'The card will be removed from the wallet. Automatic charges that use it may fail until a new card is added.',
  },
  deleteCardError: {
    id: 'features.payments.walletInstruments.deleteCardError',
    defaultMessage: 'Could not remove the card. Please try again.',
  },
  deleteCardTitle: {
    id: 'features.payments.walletInstruments.deleteCardTitle',
    defaultMessage: 'Remove card',
  },
  emptyState: {
    id: 'features.payments.walletInstruments.emptyState',
    defaultMessage: 'No saved cards yet.',
  },
  expiryColumn: {
    id: 'features.payments.walletInstruments.expiryColumn',
    defaultMessage: 'Expires',
  },
  free: {
    id: 'features.payments.marketplaceBuyFooter.free',
    defaultMessage: 'Free',
  },
  getForFree: {
    id: 'features.payments.marketplaceBuyFooter.getForFree',
    defaultMessage: 'Get for free',
  },
  inLibrary: {
    id: 'features.payments.marketplaceBuyFooter.inLibrary',
    defaultMessage: 'In saved',
  },
  ownListing: {
    id: 'features.payments.marketplaceBuyFooter.ownListing',
    defaultMessage: 'Your listing',
  },
  labelsColumn: {
    id: 'features.payments.walletInstruments.labelsColumn',
    defaultMessage: 'Labels',
  },
  mitChip: {
    id: 'features.payments.walletInstruments.mitChip',
    defaultMessage: 'Auto-charge',
  },
  // Q3/Task 4 — the lock screen for an organization whose plan simply ran out.
  // A separate TITLE as well as a separate body: "Access to this organization is
  // suspended" reads as a punishment however softly the sentence under it is
  // worded, and nothing here is owed.
  orgEndedBody: {
    id: 'features.payments.orgEnded.body',
    defaultMessage:
      "This organization's subscription has ended, so its features are paused. Choosing a plan restores them right away.",
  },
  orgEndedChoosePlan: {
    id: 'features.payments.orgEnded.choosePlan',
    defaultMessage: 'Choose a plan',
  },
  orgEndedTitle: {
    id: 'features.payments.orgEnded.title',
    defaultMessage: 'The subscription has ended',
  },
  orgLockedBody: {
    id: 'features.payments.orgLocked.body',
    defaultMessage:
      'Access to this organization is suspended due to an unpaid balance. It will be restored as soon as the debt is settled.',
  },
  orgLockedBodyMember: {
    id: 'features.payments.orgLocked.bodyMember',
    defaultMessage:
      'Please contact your organization administrator for more information.',
  },
  orgLockedGoToBilling: {
    id: 'features.payments.orgLocked.goToBilling',
    defaultMessage: 'Go to billing',
  },
  orgLockedTitle: {
    id: 'features.payments.orgLocked.title',
    defaultMessage: 'Organization is temporarily unavailable',
  },
  purchaseCanceled: {
    id: 'features.payments.marketplaceBuy.purchaseCanceled',
    defaultMessage: 'Purchase canceled.',
  },
  purchaseProcessing: {
    id: 'features.payments.marketplaceBuy.purchaseProcessing',
    defaultMessage: 'Confirming your purchase…',
  },
  purchaseResumeCanceled: {
    id: 'features.payments.purchaseWithCard.canceled',
    defaultMessage: 'Card entry was canceled — the purchase was not completed.',
  },
  purchaseResumeProcessing: {
    id: 'features.payments.purchaseWithCard.processing',
    defaultMessage: 'Finishing your purchase — confirming the card…',
  },
  purchaseResumeTimeout: {
    id: 'features.payments.purchaseWithCard.timeout',
    defaultMessage:
      'Card confirmation is taking longer than usual — refresh this page in a minute to complete the purchase.',
  },
  // seat wording — a lost booking seat; content refunds have their own copy
  purchaseSeatRefundPending: {
    id: 'features.payments.marketplaceBuy.purchaseRefundPending',
    defaultMessage:
      'The session filled up before your payment landed — your money is being refunded.',
  },
  purchaseSeatRefunded: {
    id: 'features.payments.marketplaceBuy.purchaseRefunded',
    defaultMessage:
      'The session filled up before your payment landed — your payment has been refunded.',
  },
  purchaseContentRefundPending: {
    id: 'features.payments.marketplaceBuy.purchaseContentRefundPending',
    defaultMessage: 'This purchase is being refunded.',
  },
  purchaseContentRefunded: {
    id: 'features.payments.marketplaceBuy.purchaseContentRefunded',
    defaultMessage: 'This purchase was refunded.',
  },
  purchaseSeatBooked: {
    id: 'features.payments.marketplaceBuy.purchaseSeatBooked',
    defaultMessage: 'Your seat is booked — you will find it in your calendar.',
  },
  purchaseStillProcessing: {
    id: 'features.payments.marketplaceBuy.purchaseStillProcessing',
    defaultMessage:
      'Payment is still being processed — the content will appear in your library shortly.',
  },
  purchaseSuccess: {
    id: 'features.payments.marketplaceBuy.purchaseSuccess',
    defaultMessage: 'Purchase complete — the content is in your library.',
  },
  purchaseUnavailable: {
    id: 'features.payments.marketplaceBuy.purchaseUnavailable',
    defaultMessage:
      'We could not deliver this purchase. Support has been notified and will get back to you.',
  },
  seatCapCta: {
    id: 'features.payments.seatCap.cta',
    defaultMessage: 'View packages',
  },
  seatCapDescription: {
    id: 'features.payments.seatCap.description',
    defaultMessage:
      'The organization package allows up to {count} active clients — the limit has been reached. Upgrade the package to add more clients.',
  },
  seatCapDescriptionNoCount: {
    id: 'features.payments.seatCap.descriptionNoCount',
    defaultMessage:
      'The organization package client limit has been reached. Upgrade the package to add more clients.',
  },
  seatCapTitle: {
    id: 'features.payments.seatCap.title',
    defaultMessage: 'Client limit reached',
  },
  setDefaultAction: {
    id: 'features.payments.walletInstruments.setDefaultAction',
    defaultMessage: 'Set as default',
  },
  setDefaultError: {
    id: 'features.payments.walletInstruments.setDefaultError',
    defaultMessage: 'Could not set the default card.',
  },
  setDefaultSuccess: {
    id: 'features.payments.walletInstruments.setDefaultSuccess',
    defaultMessage: 'Default card updated.',
  },
  setupCanceled: {
    id: 'features.payments.walletInstruments.setupCanceled',
    defaultMessage: 'Adding the card was canceled.',
  },
  setupProcessing: {
    id: 'features.payments.walletInstruments.setupProcessing',
    defaultMessage: 'Confirming your card…',
  },
  setupStillProcessing: {
    id: 'features.payments.walletInstruments.setupStillProcessing',
    defaultMessage:
      'Card confirmation is taking longer than usual — check again in a minute.',
  },
  setupSuccess: {
    id: 'features.payments.walletInstruments.setupSuccess',
    defaultMessage: 'Card added.',
  },
  tableLabel: {
    id: 'features.payments.walletInstruments.tableLabel',
    defaultMessage: 'Saved cards',
  },
  unknownCard: {
    id: 'features.payments.walletInstruments.unknownCard',
    defaultMessage: 'Card',
  },
  termsOfUseAcceptLabel: {
    id: 'features.payments.marketplaceBuyFooter.termsOfUseAcceptLabel',
    defaultMessage: 'I agree to the <link>Terms of Use</link> of this seller',
  },
  termsOfUseLink: {
    id: 'features.payments.marketplaceBuyFooter.termsOfUseLink',
    defaultMessage: 'Terms of Use',
  },
  termsOfUseDialogTitle: {
    id: 'features.payments.marketplaceBuyFooter.termsOfUseDialogTitle',
    defaultMessage: 'Terms of Use',
  },
  termsOfUseDialogClose: {
    id: 'features.payments.marketplaceBuyFooter.termsOfUseDialogClose',
    defaultMessage: 'Close',
  },
  termsOfUseDialogAcceptLabel: {
    id: 'features.payments.marketplaceBuyDialog.termsOfUseAcceptLabel',
    defaultMessage: 'I agree to the Terms of Use of this seller',
  },
  termsOfUseDialogCancel: {
    id: 'features.payments.marketplaceBuyDialog.termsOfUseDialogCancel',
    defaultMessage: 'Cancel',
  },
  termsOfUseDialogConfirm: {
    id: 'features.payments.marketplaceBuyDialog.termsOfUseDialogConfirm',
    defaultMessage: 'Continue to checkout',
  },
  clientMembershipAlertUnpaid: {
    id: 'features.payments.clientMembershipAlert.unpaid',
    defaultMessage:
      'Your membership at {organization} has not been paid. Please settle it or contact your trainer.',
  },
  clientMembershipAlertExpired: {
    id: 'features.payments.clientMembershipAlert.expired',
    defaultMessage:
      'Your membership at {organization} has expired. Renew it to keep booking sessions.',
  },
  clientMembershipAlertView: {
    id: 'features.payments.clientMembershipAlert.view',
    defaultMessage: 'View membership',
  },
});

export default messages;
